// Prefer an explicit VITE_API_URL for cross-origin deployments (e.g. Cloudflare
// Pages frontend talking to a Railway backend). Fall back to a same-origin
// relative `/api` base when not set — which also covers the Replit-era layout
// where the api-server served both the API and the static bundle.
const RAW_API_BASE =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_API_URL) ||
  `${(typeof import.meta !== 'undefined' && (import.meta as any).env?.BASE_URL) || '/'}api`;

// Normalize to strip a trailing slash so we can safely concatenate paths.
const API_BASE = String(RAW_API_BASE).replace(/\/+$/, '');

export function apiUrl(path: string): string {
  const clean = path.startsWith('/api/')
    ? path.slice(4)
    : path.startsWith('/api')
      ? path.slice(4)
      : path;
  return `${API_BASE}${clean.startsWith('/') ? clean : `/${clean}`}`;
}
